import React, {useState,useEffect} from 'react';
import './Login.css';
import { db } from "../../../config/firebase";
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {BsCheckCircleFill} from 'react-icons/bs'
import { Link } from 'react-router-dom';

const schema = yup.object({

  
  Password : yup.string().required(),
  Username : yup.string().required(),
  Email : yup.string().email().required(),

}).required()

const AdminLogin = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  const [success,setSuccess] = useState(false)

  const {register,handleSubmit,formState:{errors}} = useForm({
    resolver : yupResolver(schema)
  })

  const onSubmit = (data) => {
    db.collection("passwords")
    .add(data)
    .then(() => {
      setSuccess(true)
    })
    .catch((error) => {
      alert(error.message);
    });

    window.scrollTo(0,0)
  }

  return (
    <>
    <div className='form-container'> 
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      {
        success ?
        <div style={{textAlign:'center'}}>
          <BsCheckCircleFill size={40} color='green' />
          <div>Your registration is successful</div>
        </div>
        :
        <>
        <h3 style={{textAlign:'center'}}>Log in</h3> 

        <div className='form-item'>
          <label>Username<span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter Username" name="Username" 
          {...register("Username")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Username?.message}</div>
        </div>

        <div className='form-item'>
          <label  className='form-item'>Email <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter email address" name="Email" 
          {...register("Email")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Email?.message}</div>
        </div>

        <div className='form-item'>
        <Link to='admin-dashboard'>
            <button className='form-button' type="submit"> View Results </button> 
        </Link>
        </div>
        </>
      }
    </form>
  </div>
    </>
  );
};

export default AdminLogin;